module.exports = __webpack_public_path__ + "static/media/Manos1R.842ee15c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Manos1R.png
// module id = 189
// module chunks = 0